import Remote from "stimulus-remote-rails";

export default class extends Remote {
  static targets = ["modalContent", "form"];

  declare modalContentTarget: HTMLElement;
  declare formTarget: HTMLFormElement;

  connect() {
    super.connect();
  }

  append(event: CustomEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const [data, ,] = event.detail;

    if (data.reload_page) {
      window.location.reload();
      return;
    }
    // replace_content supports both formats:
    // 1. simple html string to replace without selector id (no div id provided)
    // 2. flexible object with collection of key value (selector id as key, html as value)
    if (data.replace_content) {
      if (
        typeof data.replace_content === "object" &&
        data.replace_content !== null
      ) {
        Object.keys(data.replace_content).forEach((selectorId) => {
          const element = document.getElementById(selectorId);
          if (element) {
            element.innerHTML = data.replace_content[selectorId];
          } else {
            console.warn(`[modal-remote] Cannot find target ID: ${selectorId}`);
          }
        });
      } else {
        this.modalContentTarget.innerHTML = data.replace_content;
      }
    }
  }
  close(event?: Event) {
    if (event) {
      event.preventDefault();
    }

    const element = event.currentTarget as HTMLElement;
    const modalId = element.dataset.modalId;

    if (!modalId) {
      console.error("No `data-modal-id` provided");
      return;
    }

    const modal = document.querySelector(`[id='${modalId}']`);
    if (modal) {
      modal.innerHTML = "";
    } else {
      console.warn(`[modal-remote] Can't find modal with ID: ${modalId}`);
    }
  }
  clear() {
    this.formTarget.reset();
  }
}
